// import BulmaPagination from './BulmaPagination'
// const BulmaPagination = () => import('./BulmaPagination')
// const BulmaPagination = () => import(/* webpackChunkName: "common" */ './BulmaPagination')
const BulmaPagination = r => require.ensure([], () => r(require('./BulmaPagination.vue')), 'shared')

export default BulmaPagination
